export type I18nNomenclatureNames = {
    language: string
    value: string
}

export type I18nNomenclature = {
    names: I18nNomenclatureNames[]
    validFrom?: string
    validTo?: string
    position?: number
}

export type Country = I18nNomenclature & {
    alpha2: string
    alpha3: string
    numeric: string
    official: string
}

export type Currency = I18nNomenclature & {
    alpha: string
    numeric: string
    symbol: string
    decimals: number
}

export type VatType = I18nNomenclature & {
    id: string
    percentage: number
    country: string
    exempt: boolean
}

export type MoneyDto = {
    amount: string
    currency: string
}

export type Language = I18nNomenclature & {
    alpha: string
    nativeName: string
    isLtr: boolean
}

export type LegalStructure = I18nNomenclature & {
    alpha: string
}

export const UNKNOWN_CURRENCY: Currency = {
    alpha: '',
    numeric: '',
    names: [
        { language: 'en', value: 'Unknown' },
        { language: 'nl', value: 'Onbekend' },
    ],
    symbol: '¤',
    decimals: 2,
    position: null,
}

export enum I18nAction {
    GetCountries = 'GET_COUNTRIES',
    GetCurrencies = 'GET_CURRENCIES',
    GetLanguages = 'GET_LANGUAGES',
    ResetCountries = 'RESET_COUNTRIES',
    ResetCurrencies = 'RESET_CURRENCIES',
    ResetLanguages = 'RESET_LANGUAGES',
}
